import { FunctionComponent } from 'react';

import { StyledSwitch } from './ToggleSwitch.styles';
import { ToggleSwitchProps } from './ToggleSwitch.types';

const ToggleSwitch: FunctionComponent<ToggleSwitchProps> = (
  props: ToggleSwitchProps
): JSX.Element => (
  <StyledSwitch
    classes={{
      root: 'toggleSwitch',
    }}
    {...props}
  />
);

ToggleSwitch.defaultProps = {
  color: 'primary',
};

export default ToggleSwitch;
